import * as types from '../actions/action-types';

const INITIAL_STATE = {
    jwtToken: null,
    refreshID: null,
    authentication: false,
    devLoginErrorMessage: null
};

//Authentication
export const getAuthentication = state => state.authentication;
export const getJwtToken = state => state.jwtToken;
export const getDevLoginErrorMessage = state => state.devLoginErrorMessage;

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.AUTH_USER) {
        return {
            ...state,
            jwtToken: action.jwtToken,
            refreshID: action.refreshId,
            authentication: true
        };
    } else if (action.type === types.UNAUTH_USER) {
        return {
            ...state,
            jwtToken: null,
            refreshID: null,
            authentication: false
        };
    } else if (action.type === types.DEV_ERROR_LOGIN_MESSAGE) {
        return {
            ...state,
            devLoginErrorMessage: action.errorMessage
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js